// Import FullCalendar packages according to ES6 initialization documentation
// https://fullcalendar.io/docs/initialize-es6
import { Calendar } from "@fullcalendar/core";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";

// In FullCalendar v6, CSS is automatically injected by the JavaScript
// No need to import CSS files separately

// Make FullCalendar globally available
window.FullCalendar = {
  Calendar,
  plugins: {
    bootstrap5: bootstrap5Plugin,
    dayGrid: dayGridPlugin,
    timeGrid: timeGridPlugin,
    list: listPlugin,
    interaction: interactionPlugin
  }
};